// lib files
import { getActiveMembershipsByUID } from "@/lib/mvault/direct";
import safeFetch from "@/lib/helpers/safe-fetch";
import stationServices from '@/lib/station-services/client';

// types
import { PassportTransferMembership } from "@/lib/types/passportTransferMembership";

export async function fetchActivePassportMemberships(uid: string) {
  const response = await safeFetch(`/api/v1/membership/${uid}/passport/active/`)
  return await response.json()
}

export async function getActivePassportMembershipsWithStationData(uid: string): Promise<PassportTransferMembership[]> {
  const activeMemberships = await getActiveMembershipsByUID(uid);

  const stationDataPromises = activeMemberships.map(async (membership: PassportTransferMembership) => {
    const stationId = membership.station_id;

    const stationData = stationId
      ? await stationServices.getStationDataByStationId(stationId)
      : null;

    return {
      ...membership,
      station_data: stationData ?? null,
    };
  });

  return Promise.all(stationDataPromises);
}
